export default function ApplicationLogo(props) {
    return (
        <svg
            width="300px"
            height="100px"
            viewBox="0 0 1924 404"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
            xmlnsSerif="http://www.serif.com/"
            style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
                strokeLinejoin: "round",
                strokeMiterlimit: 2,
            }}
        >
            <g transform="matrix(1,0,0,1,-792.418,-1038.55)">
                <g id="Layer-1" data-serif-id="Layer 1" transform="matrix(4.16667,0,0,4.16667,0,0)">
                    <g transform="matrix(1,0,0,1,300.637,322.081)">
                        <path
                            d="M0,-38.051C-2.384,-36.568 -4.242,-34.542 -5.575,-31.976C-6.909,-29.408 -7.575,-26.476 -7.575,-23.176C-7.575,-19.908 -6.909,-16.984 -5.575,-14.401C-4.242,-11.818 -2.384,-9.783 0,-8.301C2.383,-6.818 5.141,-6.075 8.275,-6.075C11.441,-6.075 14.208,-6.818 16.575,-8.301C18.941,-9.783 20.791,-11.818 22.125,-14.401C23.458,-16.984 24.125,-19.908 24.125,-23.176C24.125,-26.476 23.458,-29.408 22.125,-31.976C20.791,-34.542 18.941,-36.568 16.575,-38.051C14.208,-39.533 11.441,-40.276 8.275,-40.276C5.141,-40.276 2.383,-39.533 0,-38.051M20.925,4.925L12.525,-4.876L14.725,-4.426C14.058,-4.193 13.357,-3.993 12.625,-3.825C11.891,-3.659 11.166,-3.543 10.45,-3.476C9.732,-3.409 9.008,-3.376 8.275,-3.376C4.508,-3.376 1.208,-4.226 -1.625,-5.926C-4.459,-7.626 -6.659,-9.967 -8.225,-12.95C-9.792,-15.934 -10.575,-19.342 -10.575,-23.176C-10.575,-27.009 -9.792,-30.417 -8.225,-33.401C-6.659,-36.384 -4.459,-38.726 -1.625,-40.426C1.208,-42.126 4.508,-42.976 8.275,-42.976C12.075,-42.976 15.383,-42.126 18.2,-40.426C21.016,-38.726 23.208,-36.384 24.775,-33.401C26.341,-30.417 27.125,-27.009 27.125,-23.176C27.125,-20.042 26.591,-17.184 25.525,-14.601C24.458,-12.017 22.941,-9.842 20.975,-8.075C19.008,-6.309 16.675,-5.059 13.975,-4.325L15.125,-6.026L22.975,3.175L20.925,4.925Z"
                            style={{
                                fill: "rgb(40,94,111)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,383.661,315.554)">
                        <path
                            d="M0,-33.298L-5,-33.298L-5,-35.649L9.85,-35.649L9.85,-33.298L2.9,-33.298L2.9,-0.048L20.8,-0.048L20.8,-9.349L23.35,-9.349L23.35,2.351L-5,2.351L-5,0.002L0,0.002L0,-33.298Z"
                            style={{
                                fill: "rgb(40,94,111)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,433.761,315.554)">
                        <path
                            d="M0,-33.298L-5,-33.298L-5,-35.649L7.9,-35.649L7.9,-33.298L2.9,-33.298L2.9,0.002L7.9,0.002L7.9,2.351L-5,2.351L-5,0.002L0,0.002L0,-33.298Z"
                            style={{
                                fill: "rgb(40,94,111)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,465.41,316.655)">
                        <path
                            d="M0,-35.5L1.2,-34.399L-3.45,-34.399L-3.45,-36.75L9.851,-36.75L9.851,-34.399L2.75,-34.399L3.25,-35.25L16.65,-0.35L15.5,-0.35L29.101,-35.399L29.65,-34.399L22.4,-34.399L22.4,-36.75L35.5,-36.75L35.5,-34.399L30.301,-34.399L32.051,-35.399L17.75,1.25L14.301,1.25L0,-35.5Z"
                            style={{
                                fill: "rgb(40,94,111)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,526.211,315.554)">
                        <path
                            d="M0,-33.298L-5,-33.298L-5,-35.649L7.899,-35.649L7.899,-33.298L2.899,-33.298L2.899,0.002L7.899,0.002L7.899,2.351L-5,2.351L-5,0.002L0,0.002L0,-33.298Z"
                            style={{
                                fill: "rgb(40,94,111)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,590.06,279.905)">
                        <path
                            d="M0,38L-3.45,38L-26.4,2.9L-25.851,2.75L-25.851,35.65L-19.45,35.65L-19.45,38L-33.55,38L-33.55,35.65L-28.55,35.65L-28.55,2.351L-33.55,2.351L-33.55,0L-25,0L-2.05,35L-2.75,35.2L-2.75,2.351L-9.15,2.351L-9.15,0L5,0L5,2.351L0,2.351L0,38Z"
                            style={{
                                fill: "rgb(40,94,111)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,651.71,279.905)">
                        <path
                            d="M0,38L-2.351,38L-2.351,27.45L-1.7,28.45C-2.034,30.25 -2.859,31.942 -4.176,33.525C-5.492,35.108 -7.209,36.384 -9.325,37.351C-11.442,38.316 -13.867,38.8 -16.601,38.8C-19.434,38.8 -22,38.316 -24.301,37.351C-26.601,36.384 -28.559,35.009 -30.176,33.226C-31.793,31.442 -33.034,29.334 -33.9,26.9C-34.768,24.468 -35.2,21.784 -35.2,18.851C-35.2,15.983 -34.793,13.351 -33.976,10.95C-33.159,8.55 -31.976,6.476 -30.426,4.726C-28.875,2.976 -26.992,1.617 -24.775,0.65C-22.559,-0.316 -20.067,-0.8 -17.301,-0.8C-14.634,-0.8 -12.268,-0.366 -10.2,0.5C-8.134,1.367 -6.459,2.525 -5.176,3.976C-3.893,5.425 -3.067,7.018 -2.7,8.75L-3.4,9.3L-3.4,-0L-1,-0L-1,14.7L-3.45,14.7L-3.45,14.15C-3.45,12.317 -3.775,10.65 -4.426,9.15C-5.075,7.65 -6.009,6.351 -7.226,5.25C-8.442,4.15 -9.884,3.309 -11.551,2.726C-13.218,2.143 -15.034,1.851 -17,1.851C-20.2,1.851 -22.942,2.584 -25.226,4.05C-27.509,5.518 -29.242,7.534 -30.426,10.101C-31.609,12.667 -32.2,15.584 -32.2,18.851C-32.2,22.218 -31.601,25.2 -30.4,27.8C-29.2,30.4 -27.426,32.45 -25.075,33.95C-22.726,35.45 -19.834,36.2 -16.4,36.2C-13.7,36.2 -11.301,35.634 -9.2,34.5C-7.101,33.367 -5.442,31.809 -4.226,29.825C-3.009,27.843 -2.4,25.534 -2.4,22.9L-2.4,21.15L-1.5,22.3L-14.801,22.3L-14.801,19.9L0,19.9L0,38Z"
                            style={{
                                fill: "rgb(40,94,111)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,215.711,283.476)">
                        <path
                            d="M0,-18.372C-5.065,-18.372 -9.186,-14.251 -9.186,-9.186C-9.186,-4.121 -5.065,0 0,0C5.065,0 9.186,-4.121 9.186,-9.186C9.186,-14.251 5.065,-18.372 0,-18.372M0,5.437C-8.063,5.437 -14.623,-1.123 -14.623,-9.186C-14.623,-17.249 -8.063,-23.809 0,-23.809C8.063,-23.809 14.623,-17.249 14.623,-9.186C14.623,-1.123 8.063,5.437 0,5.437"
                            style={{
                                fill: "rgb(66,153,167)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,197.198,254.689)">
                        <path
                            d="M0,85.898L37.025,85.898L24.738,38.282L26.783,37.325C33.659,34.112 38.102,27.15 38.102,19.589C38.102,8.788 29.314,0 18.512,0C7.711,0 -1.077,8.788 -1.077,19.589C-1.077,27.15 3.366,34.112 10.241,37.325L12.287,38.282L0,85.898ZM44.043,91.335L-7.018,91.335L5.92,41.192C-1.701,36.739 -6.514,28.49 -6.514,19.589C-6.514,5.79 4.713,-5.437 18.512,-5.437C32.312,-5.437 43.539,5.79 43.539,19.589C43.539,28.49 38.725,36.739 31.104,41.192L44.043,91.335Z"
                            style={{
                                fill: "rgb(40,94,111)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(-0.255586,-0.966786,-0.966786,0.255586,236.38,283.6)">
                        <path
                            d="M-14.712,16.414L13.979,16.414L12.545,10.975L-14.726,10.977L-14.712,16.414Z"
                            style={{
                                fill: "rgb(40,94,111)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,228.955,293.584)">
                        <path
                            d="M0,42.62L-26.448,42.62L-15.629,0.136C-15.629,0.136 -14.955,0.335 -12.804,0.275C-10.858,0.221 -9.927,0 -9.927,0L-19.43,37.183L-1.204,37.183L0,42.62Z"
                            style={{
                                fill: "rgb(66,153,167)",
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
